import { createContext, useState } from "react";

export const BlockEContextData = createContext({
    initialData: null,
    setInitialData: null
});

const BlockEContextProvider = ({ children }) => {
    const[initialData,setInitialData]=useState(null)

    return (
        <BlockEContextData.Provider value={{setInitialData,initialData}}>
            {children}
        </BlockEContextData.Provider>
    );
};

export default BlockEContextProvider;
